import $ from 'jquery';
import { changeImageSrc } from '~src/utils';
import { stopExpand } from '~core/expand';
import { getState } from '~src/state';
import { getBase64ImageByUrl } from '~src/utils';
import { b64toBlob } from '~core';
import {
  startAiLoader,
  stopAiLoader,
  showAiSuccessMessage,
} from '~core/aiLoader';
import { handleTabImagesAI } from '~src/sidebar/index';

export default async function applyExpand() {
  startAiLoader(
    [
      { icon: '💾', text: 'Salvando la scena espansa...' },
      { icon: '✅', text: 'Applicando al progetto...' },
    ],
    '💾 Salvataggio in corso'
  );

  const expandedImage = window.expandDrawingCanvas
    .getObjects()
    .find((obj) => obj.id === 'expanded-image');

  if (!expandedImage) {
    console.error('No expanded image found on expand canvas');
    stopAiLoader();
    return;
  }

  const expandedImageUrl =
    expandedImage.getSrc() ||
    expandedImage._element?.src ||
    expandedImage._element?.currentSrc;
  if (!expandedImageUrl) {
    console.error('No source URL for the expanded image', {
      expandedImage,
      getSrc: expandedImage.getSrc(),
      elementSrc: expandedImage._element?.src,
      elementCurrentSrc: expandedImage._element?.currentSrc,
    });
    stopAiLoader();
    return;
  }

  const imageBase64 = await getBase64ImageByUrl(expandedImageUrl);
  const blob = b64toBlob(imageBase64, 'image/jpeg');
  const attachmentsUploader = getState('uploader.allegati');

  attachmentsUploader.onComplete = attachmentsUploader.addFile({
    type: blob.type,
    data: blob,
    meta: {
      customAttachmentProps: {
        expandRawImage: getState('expandRawImage'),
        isExpand: true,
      },
    },
  });

  const responseUpload = await attachmentsUploader.upload();

  attachmentsUploader.cancelAll();

  const selection = getState('expandSelection');

  const imageUrl = `${process.env.EDGE_RESIZER}${
    new URL(responseUpload.successful[0].uploadURL).pathname
  }`;

  // Check if the selection has a magic frame
  let magicFrame = selection._magicFrame;
  if (selection.type === 'MagicFrame') {
    magicFrame = selection;
  }

  if (magicFrame) {
    // If it's a magic frame, update the person image
    await magicFrame.updatePerson(imageUrl);
    magicFrame.scalePersonToWidth(magicFrame.width * magicFrame.scaleX);
    magicFrame.scalePersonToWidth(magicFrame.width * magicFrame.scaleX);
    window.canvas.requestRenderAll();
  } else {
    // If it's a regular image, change the image source
    await changeImageSrc(selection, imageUrl);
    selection.setCoords();
    window.canvas.requestRenderAll();
  }

  $('#editor-menu-exec-ai-expand').prop('disabled', true);
  $('#editor-menu-apply-ai-expand').prop('disabled', true);

  stopExpand();
  stopAiLoader();

  // Show success message
  showAiSuccessMessage(
    'Espansione Completata',
    'La scena è stata espansa e salvata con successo!'
  );

  // Refresh the sidebar to show the new attachment
  handleTabImagesAI();
}
